"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utcToRelative = void 0;
var HourFormat;
(function (HourFormat) {
    HourFormat["t12"] = "12";
    HourFormat["t24"] = "24";
})(HourFormat || (HourFormat = {}));
var MonthFormat;
(function (MonthFormat) {
    MonthFormat["full"] = "full";
    MonthFormat["concat"] = "concat";
})(MonthFormat || (MonthFormat = {}));
var utcToRelative = function (utc, hourFormat, monthFormat, currentTime) {
    if (utc === void 0) { utc = new Date().getTime(); }
    if (hourFormat === void 0) { hourFormat = HourFormat.t24; }
    if (monthFormat === void 0) { monthFormat = MonthFormat.full; }
    if (currentTime === void 0) { currentTime = new Date().getTime(); }
    var currentDate = new Date(currentTime);
    var getDayName = function (dayDate) {
        var day = dayDate.getDay();
        return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day];
    };
    var getMonthName = function (monthDate) {
        var month = monthDate.getMonth();
        return monthFormat === 'full'
            ? [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ][month]
            : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month];
    };
    var getTwoDigitInteger = function (integer) {
        if (integer <= 9) {
            return "0".concat(integer);
        }
        else {
            return "".concat(integer);
        }
    };
    var daysDiff = (utc - Date.now()) / 86400000;
    var date = new Date(utc);
    var dayOfMonth = date.getDate();
    var currentDayOfMonth = currentDate.getDate();
    var returnString = '';
    if (daysDiff <= 6 && daysDiff >= -6) {
        if (dayOfMonth === currentDayOfMonth) {
            returnString += 'Today';
        }
        else if (currentDayOfMonth - dayOfMonth === 1) {
            returnString += 'Yesterday';
        }
        else if (currentDayOfMonth - dayOfMonth === -1) {
            returnString += 'Tomorrow';
        }
        else {
            returnString += getDayName(date);
            if (daysDiff < 0)
                returnString = 'Last ' + returnString;
        }
    }
    else {
        var isSameYear = date.getFullYear() === currentDate.getFullYear();
        returnString += "".concat(dayOfMonth, " ").concat(getMonthName(date)).concat(isSameYear ? '' : ' ' + date.getFullYear());
    }
    returnString += ', ';
    if (hourFormat === '24') {
        returnString += "".concat(date.getHours(), ":").concat(getTwoDigitInteger(date.getMinutes()));
    }
    else {
        var isAM = date.getHours() / 12 < 1;
        returnString += "".concat(isAM ? date.getHours() : date.getHours() - 12, ":").concat(getTwoDigitInteger(date.getMinutes()), " ").concat(isAM ? 'am' : 'pm');
    }
    return returnString;
};
exports.utcToRelative = utcToRelative;
